import { frontendURL } from 'dashboard/helper/URLHelper';

const KanbanView = () => import('./kanban/KanbanView.vue');
const ListView = () => import('./list/ListView.vue');
const FunnelView = () => import('./funnel/FunnelView.vue');
const CalendarView = () => import('./calendar/CalendarView.vue');
const ProductsView = () => import('./products/ProductsView.vue');
const CrmSettings = () => import('./settings/CrmSettings.vue');
const CrmAdminSettings = () => import('./settings/CrmAdminSettings.vue');

const crmMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_dashboard',
    redirect: to => ({
      name: 'crm_kanban',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/crm/kanban'),
    name: 'crm_kanban',
    component: KanbanView,
    meta: crmMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/list'),
    name: 'crm_list',
    component: ListView,
    meta: crmMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/funnel'),
    name: 'crm_funnel',
    component: FunnelView,
    meta: crmMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/calendar'),
    name: 'crm_calendar',
    component: CalendarView,
    meta: crmMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/products'),
    name: 'crm_products',
    component: ProductsView,
    meta: crmMeta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/settings'),
    name: 'crm_settings',
    component: CrmSettings,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/settings/crm'),
    name: 'crm_admin_settings',
    component: CrmAdminSettings,
    meta: {
      permissions: ['administrator'],
    },
  },
];
